<template>
    <q-spinner-ball    color="primary" size="2em"/>
</template>

<script>
import {QSpinnerBall} from 'quasar'
export default {
    components: {
        QSpinnerBall
    },
    props: {
    },
    data() {
        return {
            
        }
    },
    watch: {
    },
    created() {
    },
    methods: {
        
    }
}
</script>
